// Harmonia Admin Auth Module

const auth = {
  // Check if user is authenticated
  isAuthenticated() {
    return !!localStorage.getItem('admin_token');
  },

  // Check auth and redirect to login if not authenticated
  requireAuth() {
    if (!this.isAuthenticated()) {
      // Don't redirect if already on login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login/';
      }
      return false;
    }
    return true;
  },

  // Redirect to dashboard if already authenticated (for login page)
  redirectIfAuthenticated() {
    if (this.isAuthenticated()) {
      window.location.href = '/';
    }
  },
};

// Auto check auth on page load (except login page)
window.addEventListener('DOMContentLoaded', () => {
  const isLoginPage = window.location.pathname.includes('/login');

  if (isLoginPage) {
    // If on login page and already authenticated, redirect to dashboard
    auth.redirectIfAuthenticated();
  } else {
    // If on protected page, require authentication
    auth.requireAuth();
  }
});

window.auth = auth;
export default auth;
